(function () {
  'use strict';

  /* @ngdoc object
   * @name moment
   * @description
   *
   */
  angular
    .module('moment', [
    ]);
}());
